//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowRedo(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M15.03 12L17.55 9H10.4997C8.01445 9 5.99973 11.0147 5.99973 13.5C5.99973 15.9853 8.01445 18 10.4997 18H10.9997V20H10.4997C6.90988 20 3.99973 17.0899 3.99973 13.5C3.99973 9.91015 6.90988 7 10.4997 7H17.55L15.03 4H17.64L21 8L17.64 12H15.03Z" fill="currentColor" /></svg>;
}
export default IconArrowRedo;